import { Language } from 'src/shared/constants/languages';
import { resources } from './resources';
const config = {
    resources,
    load: 'currentOnly',
    fallbackLng: Language.En,
    debug: process.env.TARGET_ENV === 'development',
    interpolation: {
        escapeValue: false
    }
};
export default config;
